import { Wallet } from "@models/interfaces";
import { TYPE_NAME_FIAT } from "@helpers/constants";

export class FiatWallet extends Wallet {
	public static TypeName: string = TYPE_NAME_FIAT;

	private fiat_id: string = "";

	private cashPlusBalance = 0;

	private fiat_symbol: string = "";

	public getCashPlusBalance(): number {
		return this.cashPlusBalance;
	}

	public setCashPlusBalance(balance: number): void {
		this.cashPlusBalance = balance;
	}

	public getFiatId(): string {
		return this.fiat_id;
	}

	public setFiatId(id: string): void {
		this.fiat_id = id;
	}

	public getCurrencyId(): string {
		return this.getFiatId();
	}

	public setCurrencyId(id: string): void {
		this.fiat_id = id;
	}

	public isNew(): boolean {
		return this.isNewWallet;
	}

	public setNew(b: boolean): void {
		this.isNewWallet = b;
	}

	public getBaseUrl(): string {
		return "/fiat-wallet/";
	}

	public getFiatSymbol(): string {
		return this.fiat_symbol;
	}
}
